import React from 'react';
import { Typography, Divider } from '@material-ui/core';
import { formatPrice } from '@rcg/pricing-format';
import { useGlobal } from '@rcg/ui-react';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import Button from '../UiComponents/Button';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-x_blue.svg';
import useStyles from './index.style';

const CancellationFees = ({ setOpenCancellationFeesDrawer, flightInfo, currency }) => {
  const classes = useStyles();
  const {
    data: { localizedDayjs },
  } = useGlobal();
  const getDictionary = useDictionary(Dictionary);

  const feeBeforeDueDate = formatPrice(flightInfo?.airFee, currency, true, true, true);
  const feeAfterDueDate = formatPrice(flightInfo?.airFeeAfterDueDate, currency, true, true, true);
  const dueDate = localizedDayjs(flightInfo?.paymentDate).format('MMM D[,] YYYY');
  const dayBeforeDueDate = localizedDayjs(flightInfo?.paymentDate)
    .subtract(1, 'day')
    .format('MMM D[,] YYYY');

  const closeCancellationFeesDrawer = () => {
    setOpenCancellationFeesDrawer(false);
  };
  return (
    <>
      <div className={classes.closeButton}>
        <Button
          color="secondary"
          variant="text"
          disableRipple
          className="button-text"
          onClick={closeCancellationFeesDrawer}>
          <CloseIcon />
        </Button>
      </div>
      <div className={classes.cancellationInfoWrapper}>
        <Typography variant="h1">
          {getDictionary(Dictionary.airCancellationFeesTitle.key)}
        </Typography>
        <Typography variant="body2">
          {getDictionary(Dictionary.airCancellationFeesSubtitle.key)}
        </Typography>
        <div className={classes.cancellationFeesHeader}>
          <span className="label">
            {getDictionary(Dictionary.airCancellationFeesCancelAfter.key)}
          </span>
          <span className="label">{getDictionary(Dictionary.airCancellationFeesPenalty.key)}</span>
        </div>
        <Divider />
        <div className={classes.cancellationFeesInfo}>
          <span className="value">{dayBeforeDueDate}</span>
          <span className="value">
            {`${feeBeforeDueDate} / ${getDictionary(Dictionary.airPersonLabel.key)}`}
          </span>
        </div>
        <div className={classes.cancellationFeesInfo}>
          <span className="value">{dueDate}</span>
          <span className="value">
            {`${feeAfterDueDate} / ${getDictionary(Dictionary.airPersonLabel.key)}`}
          </span>
        </div>
      </div>
    </>
  );
};

export default CancellationFees;
